<template>
  <div>
    <crumb-tit>
      <span
        slot="breadTit"
        v-text="title"
      />
      <span
        slot="secondTit"
        v-text="title"
      />
    </crumb-tit>
    <div class="main">
      <a-alert
        :message="alertTipTxt"
        type="warning"
        show-icon
      />
      <sensitive-main
        :fields="sensitiveFields.list"
        type="sentive"
        @submit="referFields"
      />
      <sensitive-main
        type="view"
        :fields="sensitiveFields.range"
        @submit="referFields"
      />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import CrumbTit from '@/components/pc/config/CrumbTit'
import sensitiveMain from './components/Main'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    sensitiveMain,
    CrumbTit
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('config/sensitive', ['sensitiveFields', 'allSensitiveFields']),
    ...mapState(['baseinfo']),
    title () {
      const { title } = this.$route.meta
      return title
    },
    alertTipTxt () {
      return this.$t('message["1181"]')
    }
  },
  watch: {
    baseinfo (newVal) {
      document.title = this.title + ' - ' + newVal.projectname + '-' + newVal.comname
    }
  },
  async created () {
    await this.fetchSensitiveData()
  },
  methods: {
    ...mapActions('config/sensitive', ['fetchSensitiveData']),
    referFields () {
      this.fetchSensitiveData()
    }
  }
}
</script>
<style lang="scss" scoped>
.main::v-deep {
  margin: 24px 0;
  .ant-alert-warning{
      background: #FFF4E7;
      border: 1px solid #F6A953;
      border-radius: 4px;
    }
}
</style>
